import type { RecommendedNavigationItem } from 'bundles/ai-course-coach/utils/types';

type GenerateConsumerVideoLink = {
  courseSlug: string;
  itemSlug: string;
  itemId: string;
  courseId: string;
  currentCourseId?: string;
};

type GenerateCourseItemLink = {
  itemType: RecommendedNavigationItem;
  courseSlug: string;
  itemSlug: string;
  itemId: string;
};

// There's an existing way to generate in-course video item page url for the case where the recommended clip belongs to the course where Coach is used:
// CourseStore.getMaterials().getItemMetadata(itemId).getLink(). See example in static/bundles/item/components/navigation/PreviousAndNextItem.tsx.
// But that's using Fluxible store and we want to avoid using it in Coach code which is using Redux for state management. So we decided to hard code the url for now.
// TODO: Replace the hardcoded urls if we find a better way
export function generateConsumerVideoLink({
  courseSlug,
  itemSlug,
  itemId,
  courseId,
  currentCourseId,
}: GenerateConsumerVideoLink) {
  return courseId === currentCourseId
    ? `/learn/${courseSlug}/lecture/${itemId}/${itemSlug}`
    : `/lecture/${courseSlug}/${itemSlug}-${itemId}`;
}

// This is used for the recommended navigation and generates a link to a course item based on itemType
export const generateCourseItemLink = ({ itemType, courseSlug, itemSlug, itemId }: GenerateCourseItemLink) => {
  let courseItemLink;

  switch (itemType) {
    case 'lecture':
      courseItemLink = `/learn/${courseSlug}/lecture/${itemId}/${itemSlug}`;
      break;
    case 'supplement':
      courseItemLink = `/learn/${courseSlug}/supplement/${itemId}/${itemSlug}`;
      break;
    // case 'exam':
    //   // Different for practice quizzes `/learn/${courseSlug}/quiz/${itemId}/${itemSlug}`
    //   courseItemLink = `/learn/${courseSlug}/exam/${itemId}/${itemSlug}`;
    //   break;
    // case 'staffGraded':
    //   courseItemLink = `/learn/${courseSlug}/assignment-submission/${itemId}/${itemSlug}`;
    //   break;
    default:
      // If there is no itemType, we don't need to generate a link because the learner will not see the recommended navigation
      courseItemLink = '';
  }

  return courseItemLink;
};
